'use strict';

var _defaults = require('lodash/defaults');

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = function (opts) {
  return (0, _defaults2.default)(opts, {
    injectStyles: '\n    .accessibility-error {\n      border: 3px solid #f00;\n    }\n  ',
    errorClassName: 'accessibility-error',
    onError: function onError(error) {
      var style = {
        name: 'color: #895F24; font-weight: 900;',
        label: 'padding: 1px 3px; text-transform: uppercase; border-radius: 3px; background: #FEE0AF; color: #5C3611;',
        reset: ''
      };
      var name = error.name,
          element = error.element,
          message = error.message;

      console.groupCollapsed('%cA11y Error:%c %c%s%c', style.label, style.reset, style.name, name, style.reset, element);
      console.warn(message);
      console.groupEnd();
    }
  });
};